import { PasseriniAPI } from '@/services/apiService';
import type {
  TareaBase,
  TareaBaseFormData,
  TramiteTareaFormData,
  TramiteTareasPayload,
} from '../types';

const BASE_TAREAS_BASE = '/tramite-tareas-base';

/** Autogestión de la base genérica de tareas. */
export const tareasBaseService = {
  listar: async (activo?: boolean): Promise<TareaBase[]> => {
    const response = await PasseriniAPI.get(BASE_TAREAS_BASE, {
      params: activo === undefined ? undefined : { activo },
    });
    return response.data.items;
  },

  crear: async (data: TareaBaseFormData): Promise<TareaBase> => {
    const response = await PasseriniAPI.post(BASE_TAREAS_BASE, data);
    return response.data;
  },

  actualizar: async (id: string, data: Partial<TareaBaseFormData>): Promise<TareaBase> => {
    const response = await PasseriniAPI.put(`${BASE_TAREAS_BASE}/${id}`, data);
    return response.data;
  },

  eliminar: async (id: string): Promise<void> => {
    await PasseriniAPI.delete(`${BASE_TAREAS_BASE}/${id}`);
  },

  reordenar: async (items: string[]): Promise<void> => {
    await PasseriniAPI.post(`${BASE_TAREAS_BASE}/reordenar`, { items });
  },
};

const tareasUrl = (tramiteId: string | number) => `/tramites/${tramiteId}/tareas`;

/** Checklist de tareas de una escritura puntual. */
export const tramiteTareasService = {
  listar: async (tramiteId: string | number): Promise<TramiteTareasPayload> => {
    const response = await PasseriniAPI.get(tareasUrl(tramiteId));
    return response.data;
  },

  crear: async (
    tramiteId: string | number,
    data: TramiteTareaFormData
  ): Promise<TramiteTareasPayload> => {
    const response = await PasseriniAPI.post(tareasUrl(tramiteId), data);
    return response.data;
  },

  actualizar: async (
    tramiteId: string | number,
    tareaId: string,
    data: Partial<TramiteTareaFormData>
  ): Promise<TramiteTareasPayload> => {
    const response = await PasseriniAPI.put(`${tareasUrl(tramiteId)}/${tareaId}`, data);
    return response.data;
  },

  eliminar: async (tramiteId: string | number, tareaId: string): Promise<void> => {
    await PasseriniAPI.delete(`${tareasUrl(tramiteId)}/${tareaId}`);
  },

  sincronizarBase: async (tramiteId: string | number): Promise<TramiteTareasPayload> => {
    const response = await PasseriniAPI.post(`${tareasUrl(tramiteId)}/sincronizar-base`);
    return response.data;
  },
};
